<template>
  <div>
    <el-carousel
      classs="t-form-carousel"
      :height="`${config.height ? config.height : 300}px`"
      :interval="config.interval * 1000 || 5000"
      indicator-position="none"
      @change="changeCarousel"
    >
      <el-carousel-item v-for="(option, index) in carouselOptions" :key="index">
        <p class="text-center">{{ item.label }}</p>
        <el-image
          :fit="config.imageFit"
          :src="option.image"
          style="width: 100%"
          :style="{ height: `${config.height ? config.height : 300}px` }"
        />
      </el-carousel-item>
    </el-carousel>
    <div class="t-carousel-indicator">
      <div class="indicator-box">{{ curIndex + 1 }}/{{ carouselOptions.length }}</div>
    </div>
  </div>
</template>

<script>
import mixin from '../mixin'

export default {
  name: 'TImageCarousel',
  mixins: [mixin],
  data() {
    return {
      curIndex: 0 // 当前幻灯片的索引
    }
  },
  computed: {
    carouselOptions() {
      return this.getOptions() || []
    }
  },
  methods: {
    changeCarousel(val) {
      this.curIndex = val
    }
  }
}
</script>

<style lang="scss">
.t-form-carousel {
  ::v-deep .el-carousel__container {
    min-height: 150px !important;
  }
}
.t-carousel-indicator {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  .indicator-box {
    border-radius: 5px;
    padding: 4px 4px;
    font-size: 12px;
    line-height: 12px;
    color: #fdfdfe;
    background-color: #dbe3ea;
  }
}
</style>
